<template>
  <a @click="selectCategory" :class="{
      'cat_inner_block': !preview && !search && !allCategoriesView && category.image,
      'cat_inner_href': !preview && !search && !allCategoriesView && !category.image,
    }">

    <template v-if="preview || allCategoriesView || search">
      <div class="cl_img" v-if="category.image"><img :src="category.image" alt="category image"></div>
      <div class="cl_name">{{category.name}}</div>
    </template>

    <template v-else-if="tileView">
      <div class="cl_img" v-if="category.image"><img :src="category.image" alt="category image"></div>
      <div class="cl_name">{{category.name}}</div>
    </template>

    <template v-else>
      <template v-if="category.image">
        <div class="cat_inner_img">
          <div class="placeholder" style="padding-top: 310px">
            <img style="object-fit: cover; height: 310px" alt="" class="placeholded-image"
                 :src="category.image">
          </div>
        </div>
        <div class="cat_inner_info">
          {{category.name}}
        </div>
      </template>
      <template v-else>
        {{category.name}}
      </template>
    </template>
  </a>
</template>

<script>
  import {SET_MODAL, SET_SELECTED_CATEGORY} from '@/store/mutations.type'

  export default {
    name: 'CategoryItem',
    props: {
      category: Object,
      search: Boolean,
      preview: Boolean
    },
    computed: {
      allCategoriesView() {
        return this.$store.getters.selectedCategory === null || this.$store.getters.selectedCategory.id === null
      },
      tileView() {
        return this.$store.getters.categoryTileView
      }
    },
    methods: {
      async selectCategory() {
        await this.$store.commit(SET_SELECTED_CATEGORY, this.category)
        if (this.$route.name !== 'catalog') {
          await this.$router.push({name: 'catalog', params: {token: this.$store.getters.token}})
        }
        if (this.$store.getters.modal.search) {
          this.$store.commit(SET_MODAL, {modal: 'search', status: false})
          this.$store.commit(SET_MODAL, {modal: 'searchFull', status: false})
        }
      }
    }
  }
</script>

<style scoped>

  div.placeholder {
    width: 100%;
    height: 0;
    background: #f7f7f7;
    position: relative;
    border-radius: 16px;
  }

  img.placeholded-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  img.placeholded-image::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0.5) 0%, transparent 10%);
  }
</style>
